import React from "react";
import styles from "./ClientNameRenderer.module.css";
import { ClientNameRendererProps } from "./ClientNameRenderer.types";

const ClientNameRenderer: React.FC<ClientNameRendererProps> = ({ data, transporter }) => {
  const clientName = data && data["ClientName"] ? data["ClientName"] : "Not Available";
  const hasCOIResults = Boolean(data?.COIApprovalStatus);

  const handleClick = () => {
    if (!hasCOIResults || !transporter) return;
    transporter("coi_conflict_check", {
      coi_conflict_check_option: {
        clientMasterId: data.ClientMasterId,
        processedTemplateId: data.ProcessedTemplateId,
      },
    });
  };

  return (
    <div
      className={`${styles.clientNameWrapper} ${hasCOIResults ? styles.clickable : ""}`}
      onClick={handleClick}
    >
      {clientName}
    </div>
  );
};

export default ClientNameRenderer;
